export default {
  // 检查字符串是否是中文
  isChinese (str) {
    var reg = /[\u4e00-\u9fa5]/gm
    return !!reg.test(str)
  },

  // 检查字符串是否为合法手机号码
  isMobile (str) {
    var reg = /^(0|86|17951)?[1][1-9][0-9][0-9]{8}$/
    return !!reg.test(str)
  },

  // 检查字符串是否为合法邮箱
  isEmail (str) {
    // eslint-disable-next-line no-useless-escape
    var reg = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/
    // var reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
    return !!reg.test(str)
  },

  // 检查字符串是否是数字
  isNumber (str) {
    var reg = /^\d+$/
    return reg.test(str)
  },

  // 检查是否是字母
  isString (str) {
    var reg = /^[a-z]+$/
    return reg.test(str)
  },

  // 验证车牌号
  isVehicleNumber (str) {
    var reg = /^(([\u4e00-\u9fa5][a-zA-Z]|[\u4e00-\u9fa5]{2}\d{2}|[\u4e00-\u9fa5]{2}[a-zA-Z])[-]?|([wW][Jj][\u4e00-\u9fa5]{1}[-]?)|([a-zA-Z]{2}))([A-Za-z0-9]{5}|[DdFf][A-HJ-NP-Za-hj-np-z0-9][0-9]{4}|[0-9]{5}[DdFf])$/
    return reg.test(str)
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/pre_validate.js